<script setup lang="ts">
import { ZSpinner } from '@zoomcatalog/core-ui';
import { ZFeedbackPage } from '@zoomcatalog/design-system';

const locale = {
  DESIGN_LOCKED_TITLE: 'This design is being created',
  DESIGN_LOCKED_TEXT:
    'This design is still in the process of being created. Try refreshing in a couple of minutes.',
};
</script>

<template>
  <ZFeedbackPage>
    <template #title>
      {{ locale.DESIGN_LOCKED_TITLE }}
    </template>
    <template #description>
      {{ locale.DESIGN_LOCKED_TEXT }}
    </template>
    <template #action>
      <ZSpinner class="spinner" size="lg" />
    </template>
  </ZFeedbackPage>
</template>

<style lang="scss" scoped>
.spinner {
  @apply animate-spin;
}
</style>
